import React from 'react';
import Colortheme from '../Theme/Colortheme';
import URLs from '../Utils/URLUtils';
class Logo extends React.Component {

    constructor(props) {
        super(props);
    }

    home() {
        window.location.href = `${URLs.homeURL}` // not /home to discard any location state
    }

    render() {
        return (
            <img src={process.env.PUBLIC_URL + "/drawesome_short.png"} onClick={this.home} className="icon" style={{
                maxHeight: '20vh',
                maxWidth: '100%',
                padding: '1em',
                cursor: 'pointer',
                boxSizing: 'border-box',
            }} />
        );

    }
}

export default Logo;